import { render, staticRenderFns } from "./gl-page-wrap.vue?vue&type=template&id=05a616cb"
import script from "./gl-page-wrap.vue?vue&type=script&lang=js"
export * from "./gl-page-wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports